<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.adaugaServiciu')}} </h4>
        </div>
        <form class="add-user-form" id="add-service">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_1" :key="input_field.id">
                        <input type="text" class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :data-vv-as="input_field.labelName"
                               v-bind:name="input_field.inputName"
                               v-bind:id="input_field.inputName"
                               @input="calculateFinalPrice"
                               @change="calculateFinalPrice">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <input type="text"
                               class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :data-vv-as="input_field.labelName"
                               :name="input_field.inputName"
                               :id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                                <i v-bind:class="input_field.icon"></i>
                            </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="save-contact-buttons col-md-12 col-xs-12 col-lg-12">
                    <button @click.prevent='addService()' :disabled="this.$store.state.loading">
                        <i class="fas fa-check"></i>
                        {{$t('placeholder.salveaza')}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import ServicesService from '../../api-services/services.service.js'
export default {
  name: 'addsubtypes',
  data () {
    return {
      input_fields: {
        column_1: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.denumire'),
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'standard_price',
            labelName: this.$t('placeholder.pretStandard'),
            icon: 'fas fa-donate',
            model: 'standardPrice'
          },
          {
            inputName: 'discount',
            labelName: this.$t('placeholder.discount'),
            icon: 'fas fa-money-bill-wave info-tool',
            model: 'discount'
          },
          {
            inputName: 'final_price',
            labelName: this.$t('placeholder.pretFinal'),
            icon: 'fas fa-file-signature',
            model: 'finalPrice'
          }
        ],
        column_2: [
          {
            inputName: 'cost_acquisition',
            labelName: this.$t('placeholder.costAchizitie'),
            icon: 'fas fa-file-signature',
            model: ''
          },
          {
            inputName: 'addition',
            labelName: this.$t('placeholder.adaosComercial'),
            icon: 'fas fa-donate',
            model: ''
          },
          {
            inputName: 'max_discount',
            labelName: this.$t('placeholder.discountMaxim'),
            icon: 'fas fa-money-bill-wave info-tool',
            model: ''
          }
        ]
      }
    }
  },
  methods: {
    calculateFinalPrice ({ target }) {
      if (target.name === 'standard_price' || target.name === 'discount') {
        let standardPrice = parseInt(document.getElementsByName('standard_price')[0].value, 10)
        standardPrice = standardPrice > 0 ? standardPrice : 0
        let discount = parseInt(document.getElementsByName('discount')[0].value, 10)
        discount = discount > 0 ? discount : 0
        let finalPrice = document.getElementsByName('final_price')[0]
        finalPrice.value = parseInt(standardPrice * (100 - discount) / 100, 10)
        finalPrice.value = finalPrice.value > 0 ? finalPrice.value : 0
      }
    },
    addService () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('add-service'))
      ServicesService.create(formData)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          if (response.status === 201) {
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: this.$t('success.produsAdaugat'),
              'animation-type': 'css'
            })
            // var frm = document.getElementById('test-id')
            // alert(frm.offsetTop)
            window.scrollTo(0, 0)
            this.$router.push('/services')
          }
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    }
  },
  computed: {},
  created () {
    this.$store.dispatch('hideLoading')
  }
}
</script>
